import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { HotelInfoModel } from '@/__generated';
import { useTranslation } from 'react-i18next';
import HotelJapaneseName from '../App/Hotels/HotelJapaneseName';

type Props = {
  onClose: () => void;
  hotelInfo: HotelInfoModel;
};
let map: google.maps.Map;

export default function HotelDetailMap({ hotelInfo, onClose }: Props) {
  const { t } = useTranslation();
  React.useEffect(() => {
    if (hotelInfo) {
      initMap();
    }
  }, [hotelInfo]);

  const initMap = async () => {
    const { Map } = (await google.maps.importLibrary('maps')) as google.maps.MapsLibrary;
    const { Marker } = (await google.maps.importLibrary('marker')) as google.maps.MarkerLibrary;
    map = new Map(document.getElementById('hotel-detail-map') as HTMLElement, {
      zoom: 16,
      disableDefaultUI: true,
      zoomControl: true,
      gestureHandling: 'greedy',
      mapId: '4504f8b371231',
      draggableCursor: 'default',
      center: { lat: hotelInfo.latitude || 0, lng: hotelInfo.longitude || 0 },
    });
    new Marker({
      map,
      position: { lat: hotelInfo.latitude || 0, lng: hotelInfo.longitude || 0 },
      icon: {
        url: '/static/icons/icon_hotel_map.png',
      },
    });
  };

  return (
    <Modal isOpen={true} unmountOnClose={true} fullscreen>
      <ModalHeader toggle={onClose} className="text-blue-1">
        {hotelInfo.nameEn}
        <HotelJapaneseName addBefore="-" name={hotelInfo.name} />
      </ModalHeader>
      <ModalBody style={{ padding: 0 }}>
        <div id="hotel-detail-map" style={{ width: '100%', height: '100%' }} />
      </ModalBody>
    </Modal>
  );
}
